var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5976 19.0234H18.8125V19.7563H19.5976V19.0234Z",
    fill: "url(#paint0_linear_4605_11693)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3766 16.8281H19.5938V17.561H20.3766V16.8281Z",
    fill: "url(#paint1_linear_4605_11693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 9.51172H3.92188V10.2446H4.70475V9.51172Z",
    fill: "#FAF1CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7236 7.32031H21.9386H21.1557H20.3728V8.051V8.78387V9.51456V10.2474V10.9781V11.711V12.4395V13.1724V13.9052V14.6359V15.3688H19.5899V16.0995V16.8302H20.3728V17.563H19.5899V16.8302H18.8049V17.563H18.022V18.2937H17.2391V19.0266V19.7573H16.454H15.6712V20.4901H14.8861V21.2208H14.1032H13.3203V21.9515H14.1032H14.8861H15.6712H16.454V21.2208H17.2391H18.022V20.4901H18.8049V19.7573V19.0266H19.5899V19.7573H20.3728V19.0266V18.2937H21.1557V17.563H21.9386V16.8302V16.0995H22.7236V15.3688V14.6359H23.5087V13.9052V13.1724V12.4395V11.711V10.9781V10.2474V9.51456V8.78387V8.051V7.32031H22.7236Z",
    fill: "url(#paint2_linear_4605_11693)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8861 21.1992V21.2166H13.3203V21.9473H16.454V21.2166H18.022V21.1992H14.8861Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5976 5.125H18.8125V5.85787H19.5976V5.125Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8028 7.3193V5.12505H18.0199V4.39218H17.237V3.65932H16.452V2.92863H15.6691V2.19793H14.8775V1.46724H13.3117V0.734375H7.04866V1.46724H5.4829V2.19793H4.69782V2.92863H3.91494V3.65932H3.13424V4.39218H2.35136V5.86009H1.56631V7.32365H0.78125V14.6393H1.56631V16.1028H2.35136V17.5664H3.13424V18.2971H3.91712V19.0299H4.69999V19.7606H5.48508V20.4935H7.05083V21.2242H13.3204V20.4935H14.8862V19.7563H15.6713V19.0256H16.4541V18.2927H17.2392V17.562H18.0221V16.8292H18.805V15.3678H19.59V7.32147L18.8028 7.3193ZM3.91494 8.04999V6.58861H4.69782V5.86009H5.4829V5.1294H6.26578V4.39653H7.04866V3.66366H13.3182V4.39653H14.1011V5.1294H14.884V5.86009H15.6691V6.59295H16.452V8.05434H17.237V13.9064H16.452V15.37H15.6691V16.1006H14.8775V16.8313H14.0946V17.5642H13.3117V18.2949H7.04866V17.5642H6.26578V16.8313H5.4829V16.1006H4.69782V15.37H3.91494V13.9064H3.13424V8.04999H3.91494Z",
    fill: "url(#paint3_linear_4605_11693)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 7.31774H4.70312V8.04843V8.7813V9.51199V10.2449V10.9755V11.7084V12.4369V13.1698H5.48821V13.9027V14.6334H6.27108V15.3662H7.05396V16.0969H7.83684H8.6219V16.8276H9.40695H10.1877H10.9727H11.7556H12.5407V16.0969H13.3235H14.1065V15.3662H14.8893V14.6334H15.6744V13.9027V13.1698H16.4573V12.4369V11.7084V10.9755V10.2449V9.51199V8.7813H15.6744V8.04843V7.31774V6.58705H14.8893V5.85418H14.1065V5.12349H13.3235H12.5407V4.39062H11.7556H10.9727H10.1877H9.40695H8.6219H7.83684V5.12349H7.05396H6.27108V5.85418H5.48821V6.58705V7.31774Z",
    fill: "url(#paint4_linear_4605_11693)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9424 5.12589V4.39302V3.66016H21.1595V4.39302H20.3766H19.5938V5.12589V5.85658V6.58945H20.3766V5.85658H21.1595H21.9424V6.58945V7.32014H22.7274V6.58945V5.85658V5.12589H21.9424Z",
    fill: "url(#paint5_linear_4605_11693)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3728 2.92712V2.19642H19.5899H18.8049V1.46573H18.022V0.732865H17.2391H16.454V0H15.6712H14.8861H14.1032H13.3203V0.732865H14.1032H14.8861V1.46573H15.6712V2.19642H16.454V2.92712H17.2391V3.65781H18.022H18.8049H19.5899H20.3728H21.1557V2.92712H20.3728Z",
    fill: "url(#paint6_linear_4605_11693)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9424 5.12589V4.39302V3.66016H21.1595V4.39302H20.3766H19.5938V5.12589V5.85658V6.58945H20.3766V5.85658H21.1595H21.9424V6.58945V7.32014H22.7274V6.58945V5.85658V5.12589H21.9424Z",
    fill: "url(#paint7_linear_4605_11693)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9391 5.12589V4.39302V3.66016H21.1562V4.39302V5.12589H21.9391V5.85658V6.58945V7.32014H22.7242V6.58945V5.85658V5.12589H21.9391Z",
    fill: "#1D1D1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 1.46484H18.0234V2.19771H18.8063V1.46484Z",
    fill: "#1D1D1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 2.926H19.5976H20.3804V2.19531H19.5976H18.8125V2.926Z",
    fill: "#1D1D1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2382 1.46724H18.0211V0.734375H17.2382H16.4531V1.46724H17.2382Z",
    fill: "#1D1D1B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1679 2.92578H20.3828V3.65865H21.1679V2.92578Z",
    fill: "#1D1D1B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1032 0.732865H14.8861H15.6712H16.454V0H15.6712H14.8861H14.1032H13.3203V0.732865H14.1032Z",
    fill: "#1D1D1B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5976 16.8281H18.8125V17.561H19.5976V16.8281Z",
    fill: "#1D1D1B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7304 7.32031H21.9453H22.7304V8.051V8.78387V9.51456V10.2474V10.9781V11.711V12.4395V13.1724V13.9052V14.6359H23.5154V13.9052V13.1724V12.4395V11.711V10.9781V10.2474V9.51456V8.78387V8.051V7.32031H22.7304Z",
    fill: "#1D1D1B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 18.293V19.0258V19.7565H20.3766V19.0258V18.293H19.5938Z",
    fill: "#1D1D1B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1679 17.5625H20.3828V18.2954H21.1679V17.5625Z",
    fill: "#1D1D1B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9391 14.6328V15.3657V16.0964H21.1562V16.8271V17.5599H21.9391V16.8271V16.0964H22.7242V15.3657V14.6328H21.9391Z",
    fill: "#1D1D1B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4548 21.2188H15.6719V21.9494H16.4548V21.2188Z",
    fill: "#1D1D1B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 19.7541V19.0234H18.0234V19.7541V20.487H18.8063V19.7541Z",
    fill: "#1D1D1B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0272 20.4883H17.2422V21.2212H18.0272V20.4883Z",
    fill: "#1D1D1B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3243 20.4883V21.219H12.5414H11.7563H10.9735H10.1884H9.40768H8.62262H7.83757H7.05469V21.9497H7.83757H8.62262H9.40768H10.1884H10.9735H11.7563H12.5414H13.3243V21.219H14.1072H14.8901V20.4883H14.1072H13.3243Z",
    fill: "#1D1D1B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 19.7578H14.8906V20.4907H15.6757V19.7578Z",
    fill: "#1D1D1B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4548 19.0258H15.6719V19.7565H16.4548H17.2398V19.0258V18.293H16.4548V19.0258Z",
    fill: "#1D1D1B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0272 17.5625H17.2422V18.2954H18.0272V17.5625Z",
    fill: "#1D1D1B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 16.8281H18.0234V17.561H18.8063V16.8281Z",
    fill: "#1D1D1B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 16.0979V16.8286H19.5976V16.0979V15.3672H18.8125V16.0979Z",
    fill: "#1D1D1B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 8.04688V8.77974V9.51043V10.2433V10.974V11.7069V12.4354V13.1682V13.9011V14.6318V15.3647H20.3766V14.6318V13.9011V13.1682V12.4354V11.7069V10.974V10.2433V9.51043V8.77974V8.04688H19.5938Z",
    fill: "#1D1D1B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 6.58834V7.31903H19.5976V6.58834V5.85547H18.8125V6.58834Z",
    fill: "#1D1D1B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 4.39062H18.0234V5.12349H18.8063V4.39062Z",
    fill: "#1D1D1B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8844 16.0977H14.1016V16.8284H14.8844V16.0977Z",
    fill: "#1D1D1B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 8.04732V8.78019H16.4586V9.51088V10.2437V10.9744V11.7073V12.4358V13.1687H15.6757V13.9015V14.6322H14.8906V15.3651V16.0958H15.6757V15.3651H16.4586V14.6322V13.9015H17.2436V13.1687V12.4358V11.7073V10.9744V10.2437V9.51088V8.78019V8.04732H16.4586V7.31663V6.58594H15.6757V7.31663V8.04732Z",
    fill: "#1D1D1B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 5.85547H14.8906V6.58834H15.6757V5.85547Z",
    fill: "#1D1D1B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8844 5.125H14.1016V5.85787H14.8844V5.125Z",
    fill: "#1D1D1B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0272 3.66016H17.2422V4.39302H18.0272V3.66016Z",
    fill: "#1D1D1B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.246 2.92578H16.4609V3.65865H17.246V2.92578Z",
    fill: "#1D1D1B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4548 2.19531H15.6719V2.926H16.4548V2.19531Z",
    fill: "#1D1D1B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 1.46484H14.8906V2.19771H15.6757V1.46484Z",
    fill: "#1D1D1B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3203 1.46724H14.1032H14.8861V0.734375H14.1032H13.3203V1.46724Z",
    fill: "#1D1D1B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26725 20.4883H5.48438V21.219H6.26725H7.05013V20.4883H6.26725Z",
    fill: "#1D1D1B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 19.7578H4.70312V20.4907H5.48821V19.7578Z",
    fill: "#1D1D1B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9235 19.0258V18.293H3.14062V19.0258V19.7565H3.9235H4.70638V19.0258H3.9235Z",
    fill: "#1D1D1B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13444 17.5625H2.35156V18.2954H3.13444V17.5625Z",
    fill: "#1D1D1B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83919 18.2917H8.62425H9.4093H10.19H10.9751H11.758H12.543H13.3259V17.561H14.1088V16.8281H13.3259H12.543V17.561H11.758H10.9751H10.19H9.4093H8.62425H7.83919V16.8281H7.05632H6.27344V17.561H7.05632V18.2917H7.83919Z",
    fill: "#1D1D1B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26725 16.0977H5.48438V16.8284H6.26725V16.0977Z",
    fill: "#1D1D1B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34755 16.0977H1.5625V16.8284V17.5612H2.34755V16.8284V16.0977Z",
    fill: "#1D1D1B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5663 14.6328H0.78125V15.3657V16.0964H1.5663V15.3657V14.6328Z",
    fill: "#1D1D1B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.782905 13.1682V12.4354V11.7069V10.974V10.2433V9.51043V8.77974V8.04688H0V8.77974V9.51043V10.2433V10.974V11.7069V12.4354V13.1682V13.9011H0.782905V13.1682Z",
    fill: "#1D1D1B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49146 14.6346H4.70638V13.9039V13.1711H3.9235V12.4382V11.7097V10.9768V10.2461V9.51328V8.78258H4.70638V8.04972V7.31903H5.49146V6.58834V5.85547H4.70638V6.58834H3.9235V7.31903V8.04972H3.14062V8.78258V9.51328V10.2461V10.9768V11.7097V12.4382V13.1711V13.9039H3.9235V14.6346V15.3675H4.70638V16.0982H5.49146V15.3675V14.6346Z",
    fill: "#1D1D1B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5663 6.58834V5.85547H0.78125V6.58834V7.31903H1.5663V6.58834Z",
    fill: "#1D1D1B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26725 5.125H5.48438V5.85787H6.26725V5.125Z",
    fill: "#1D1D1B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34755 5.12349V4.39062H1.5625V5.12349V5.85418H2.34755V5.12349Z",
    fill: "#1D1D1B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83919 5.12589V4.39302H8.62425H9.4093H10.19H10.9751H11.758H12.543V5.12589H13.3259H14.1088V4.39302H13.3259V3.66016H12.543H11.758H10.9751H10.19H9.4093H8.62425H7.83919H7.05632V4.39302H6.27344V5.12589H7.05632H7.83919Z",
    fill: "#1D1D1B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13444 3.66016H2.35156V4.39302H3.13444V3.66016Z",
    fill: "#1D1D1B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92568 2.92578H3.14062V3.65865H3.92568V2.92578Z",
    fill: "#1D1D1B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 2.19531H3.92188V2.926H4.70475V2.19531Z",
    fill: "#1D1D1B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 1.46484H4.70312V2.19771H5.48821V1.46484Z",
    fill: "#1D1D1B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05013 1.46724V0.734375H6.26725H5.48438V1.46724H6.26725H7.05013Z",
    fill: "#1D1D1B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62262 0.732865H9.40768H10.1884H10.9735H11.7563H12.5414H13.3243V0H12.5414H11.7563H10.9735H10.1884H9.40768H8.62262H7.83757H7.05469V0.732865H7.83757H8.62262Z",
    fill: "#1D1D1B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1595 5.85547H20.3766V6.58834H19.5938V7.31903V8.04972H20.3766V7.31903H21.1595H21.9424V6.58834V5.85547H21.1595Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3743 3.66016H19.5914H18.8063H18.0234V4.39302H18.8063V5.12589H19.5914V4.39302H20.3743H21.1572V3.66016H20.3743Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9689 16.8271H10.1838H9.40312H8.61806V16.0964H7.83301H7.05013V15.3657H6.26725V14.6328H5.48438V15.3657V16.0964H6.26725V16.8271H7.05013H7.83301V17.5599H8.61806H9.40312H10.1838H10.9689H11.7518H12.5368V16.8271H11.7518H10.9689Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 16.0977V16.8284H13.3219H14.1048V16.0977H13.3219H12.5391Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8844 15.3672H14.1016V16.1001H14.8844V15.3672Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 13.1719H4.70312V13.9047V14.6354H5.48821V13.9047V13.1719Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 11.7057V10.9729V10.2422H3.92188V10.9729V11.7057V12.4343V13.1671H4.70475V12.4343V11.7057Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 8.78125H3.92188V9.51411H4.70475V8.78125Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5976 19.0234H18.8125V19.7563H19.5976V19.0234Z",
    fill: "url(#paint8_linear_4605_11693)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3766 16.8281H19.5938V17.561H20.3766V16.8281Z",
    fill: "url(#paint9_linear_4605_11693)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 9.51172H3.92188V10.2446H4.70475V9.51172Z",
    fill: "#FAF1CE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7236 7.32031H21.9386H21.1557H20.3728V8.051V8.78387V9.51456V10.2474V10.9781V11.711V12.4395V13.1724V13.9052V14.6359V15.3688H19.5899V16.0995V16.8302H20.3728V17.563H19.5899V16.8302H18.8049V17.563H18.022V18.2937H17.2391V19.0266V19.7573H16.454H15.6712V20.4901H14.8861V21.2208H14.1032H13.3203V21.9515H14.1032H14.8861H15.6712H16.454V21.2208H17.2391H18.022V20.4901H18.8049V19.7573V19.0266H19.5899V19.7573H20.3728V19.0266V18.2937H21.1557V17.563H21.9386V16.8302V16.0995H22.7236V15.3688V14.6359H23.5087V13.9052V13.1724V12.4395V11.711V10.9781V10.2474V9.51456V8.78387V8.051V7.32031H22.7236Z",
    fill: "url(#paint10_linear_4605_11693)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8861 21.1992V21.2166H13.3203V21.9473H16.454V21.2166H18.022V21.1992H14.8861Z",
    fill: "#1D1D1B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5976 5.125H18.8125V5.85787H19.5976V5.125Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8028 7.3193V5.12505H18.0199V4.39218H17.237V3.65932H16.452V2.92863H15.6691V2.19793H14.8775V1.46724H13.3117V0.734375H7.04866V1.46724H5.4829V2.19793H4.69782V2.92863H3.91494V3.65932H3.13424V4.39218H2.35136V5.86009H1.56631V7.32365H0.78125V14.6393H1.56631V16.1028H2.35136V17.5664H3.13424V18.2971H3.91712V19.0299H4.69999V19.7606H5.48508V20.4935H7.05083V21.2242H13.3204V20.4935H14.8862V19.7563H15.6713V19.0256H16.4541V18.2927H17.2392V17.562H18.0221V16.8292H18.805V15.3678H19.59V7.32147L18.8028 7.3193ZM3.91494 8.04999V6.58861H4.69782V5.86009H5.4829V5.1294H6.26578V4.39653H7.04866V3.66366H13.3182V4.39653H14.1011V5.1294H14.884V5.86009H15.6691V6.59295H16.452V8.05434H17.237V13.9064H16.452V15.37H15.6691V16.1006H14.8775V16.8313H14.0946V17.5642H13.3117V18.2949H7.04866V17.5642H6.26578V16.8313H5.4829V16.1006H4.69782V15.37H3.91494V13.9064H3.13424V8.04999H3.91494Z",
    fill: "url(#paint11_linear_4605_11693)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 7.31774H4.70312V8.04843V8.7813V9.51199V10.2449V10.9755V11.7084V12.4369V13.1698H5.48821V13.9027V14.6334H6.27108V15.3662H7.05396V16.0969H7.83684H8.6219V16.8276H9.40695H10.1877H10.9727H11.7556H12.5407V16.0969H13.3235H14.1065V15.3662H14.8893V14.6334H15.6744V13.9027V13.1698H16.4573V12.4369V11.7084V10.9755V10.2449V9.51199V8.7813H15.6744V8.04843V7.31774V6.58705H14.8893V5.85418H14.1065V5.12349H13.3235H12.5407V4.39062H11.7556H10.9727H10.1877H9.40695H8.6219H7.83684V5.12349H7.05396H6.27108V5.85418H5.48821V6.58705V7.31774Z",
    fill: "url(#paint12_linear_4605_11693)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9424 5.12589V4.39302V3.66016H21.1595V4.39302H20.3766H19.5938V5.12589V5.85658V6.58945H20.3766V5.85658H21.1595H21.9424V6.58945V7.32014H22.7274V6.58945V5.85658V5.12589H21.9424Z",
    fill: "url(#paint13_linear_4605_11693)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3728 2.92712V2.19642H19.5899H18.8049V1.46573H18.022V0.732865H17.2391H16.454V0H15.6712H14.8861H14.1032H13.3203V0.732865H14.1032H14.8861V1.46573H15.6712V2.19642H16.454V2.92712H17.2391V3.65781H18.022H18.8049H19.5899H20.3728H21.1557V2.92712H20.3728Z",
    fill: "url(#paint14_linear_4605_11693)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9424 5.12589V4.39302V3.66016H21.1595V4.39302H20.3766H19.5938V5.12589V5.85658V6.58945H20.3766V5.85658H21.1595H21.9424V6.58945V7.32014H22.7274V6.58945V5.85658V5.12589H21.9424Z",
    fill: "url(#paint15_linear_4605_11693)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9391 5.12589V4.39302V3.66016H21.1562V4.39302V5.12589H21.9391V5.85658V6.58945V7.32014H22.7242V6.58945V5.85658V5.12589H21.9391Z",
    fill: "#1D1D1B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 1.46484H18.0234V2.19771H18.8063V1.46484Z",
    fill: "#1D1D1B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 2.926H19.5976H20.3804V2.19531H19.5976H18.8125V2.926Z",
    fill: "#1D1D1B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2382 1.46724H18.0211V0.734375H17.2382H16.4531V1.46724H17.2382Z",
    fill: "#1D1D1B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1679 2.92578H20.3828V3.65865H21.1679V2.92578Z",
    fill: "#1D1D1B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1032 0.732865H14.8861H15.6712H16.454V0H15.6712H14.8861H14.1032H13.3203V0.732865H14.1032Z",
    fill: "#1D1D1B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5976 16.8281H18.8125V17.561H19.5976V16.8281Z",
    fill: "#1D1D1B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7304 7.32031H21.9453H22.7304V8.051V8.78387V9.51456V10.2474V10.9781V11.711V12.4395V13.1724V13.9052V14.6359H23.5154V13.9052V13.1724V12.4395V11.711V10.9781V10.2474V9.51456V8.78387V8.051V7.32031H22.7304Z",
    fill: "#1D1D1B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 18.293V19.0258V19.7565H20.3766V19.0258V18.293H19.5938Z",
    fill: "#1D1D1B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1679 17.5625H20.3828V18.2954H21.1679V17.5625Z",
    fill: "#1D1D1B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9391 14.6328V15.3657V16.0964H21.1562V16.8271V17.5599H21.9391V16.8271V16.0964H22.7242V15.3657V14.6328H21.9391Z",
    fill: "#1D1D1B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4548 21.2188H15.6719V21.9494H16.4548V21.2188Z",
    fill: "#1D1D1B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 19.7541V19.0234H18.0234V19.7541V20.487H18.8063V19.7541Z",
    fill: "#1D1D1B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0272 20.4883H17.2422V21.2212H18.0272V20.4883Z",
    fill: "#1D1D1B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3243 20.4883V21.219H12.5414H11.7563H10.9735H10.1884H9.40768H8.62262H7.83757H7.05469V21.9497H7.83757H8.62262H9.40768H10.1884H10.9735H11.7563H12.5414H13.3243V21.219H14.1072H14.8901V20.4883H14.1072H13.3243Z",
    fill: "#1D1D1B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 19.7578H14.8906V20.4907H15.6757V19.7578Z",
    fill: "#1D1D1B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4548 19.0258H15.6719V19.7565H16.4548H17.2398V19.0258V18.293H16.4548V19.0258Z",
    fill: "#1D1D1B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0272 17.5625H17.2422V18.2954H18.0272V17.5625Z",
    fill: "#1D1D1B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 16.8281H18.0234V17.561H18.8063V16.8281Z",
    fill: "#1D1D1B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 16.0979V16.8286H19.5976V16.0979V15.3672H18.8125V16.0979Z",
    fill: "#1D1D1B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 8.04688V8.77974V9.51043V10.2433V10.974V11.7069V12.4354V13.1682V13.9011V14.6318V15.3647H20.3766V14.6318V13.9011V13.1682V12.4354V11.7069V10.974V10.2433V9.51043V8.77974V8.04688H19.5938Z",
    fill: "#1D1D1B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 6.58834V7.31903H19.5976V6.58834V5.85547H18.8125V6.58834Z",
    fill: "#1D1D1B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8063 4.39062H18.0234V5.12349H18.8063V4.39062Z",
    fill: "#1D1D1B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8844 16.0977H14.1016V16.8284H14.8844V16.0977Z",
    fill: "#1D1D1B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 8.04732V8.78019H16.4586V9.51088V10.2437V10.9744V11.7073V12.4358V13.1687H15.6757V13.9015V14.6322H14.8906V15.3651V16.0958H15.6757V15.3651H16.4586V14.6322V13.9015H17.2436V13.1687V12.4358V11.7073V10.9744V10.2437V9.51088V8.78019V8.04732H16.4586V7.31663V6.58594H15.6757V7.31663V8.04732Z",
    fill: "#1D1D1B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 5.85547H14.8906V6.58834H15.6757V5.85547Z",
    fill: "#1D1D1B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8844 5.125H14.1016V5.85787H14.8844V5.125Z",
    fill: "#1D1D1B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0272 3.66016H17.2422V4.39302H18.0272V3.66016Z",
    fill: "#1D1D1B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M17.246 2.92578H16.4609V3.65865H17.246V2.92578Z",
    fill: "#1D1D1B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4548 2.19531H15.6719V2.926H16.4548V2.19531Z",
    fill: "#1D1D1B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 1.46484H14.8906V2.19771H15.6757V1.46484Z",
    fill: "#1D1D1B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3203 1.46724H14.1032H14.8861V0.734375H14.1032H13.3203V1.46724Z",
    fill: "#1D1D1B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26725 20.4883H5.48438V21.219H6.26725H7.05013V20.4883H6.26725Z",
    fill: "#1D1D1B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 19.7578H4.70312V20.4907H5.48821V19.7578Z",
    fill: "#1D1D1B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9235 19.0258V18.293H3.14062V19.0258V19.7565H3.9235H4.70638V19.0258H3.9235Z",
    fill: "#1D1D1B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13444 17.5625H2.35156V18.2954H3.13444V17.5625Z",
    fill: "#1D1D1B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83919 18.2917H8.62425H9.4093H10.19H10.9751H11.758H12.543H13.3259V17.561H14.1088V16.8281H13.3259H12.543V17.561H11.758H10.9751H10.19H9.4093H8.62425H7.83919V16.8281H7.05632H6.27344V17.561H7.05632V18.2917H7.83919Z",
    fill: "#1D1D1B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26725 16.0977H5.48438V16.8284H6.26725V16.0977Z",
    fill: "#1D1D1B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34755 16.0977H1.5625V16.8284V17.5612H2.34755V16.8284V16.0977Z",
    fill: "#1D1D1B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5663 14.6328H0.78125V15.3657V16.0964H1.5663V15.3657V14.6328Z",
    fill: "#1D1D1B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0.782905 13.1682V12.4354V11.7069V10.974V10.2433V9.51043V8.77974V8.04688H0V8.77974V9.51043V10.2433V10.974V11.7069V12.4354V13.1682V13.9011H0.782905V13.1682Z",
    fill: "#1D1D1B"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49146 14.6346H4.70638V13.9039V13.1711H3.9235V12.4382V11.7097V10.9768V10.2461V9.51328V8.78258H4.70638V8.04972V7.31903H5.49146V6.58834V5.85547H4.70638V6.58834H3.9235V7.31903V8.04972H3.14062V8.78258V9.51328V10.2461V10.9768V11.7097V12.4382V13.1711V13.9039H3.9235V14.6346V15.3675H4.70638V16.0982H5.49146V15.3675V14.6346Z",
    fill: "#1D1D1B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5663 6.58834V5.85547H0.78125V6.58834V7.31903H1.5663V6.58834Z",
    fill: "#1D1D1B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26725 5.125H5.48438V5.85787H6.26725V5.125Z",
    fill: "#1D1D1B"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34755 5.12349V4.39062H1.5625V5.12349V5.85418H2.34755V5.12349Z",
    fill: "#1D1D1B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83919 5.12589V4.39302H8.62425H9.4093H10.19H10.9751H11.758H12.543V5.12589H13.3259H14.1088V4.39302H13.3259V3.66016H12.543H11.758H10.9751H10.19H9.4093H8.62425H7.83919H7.05632V4.39302H6.27344V5.12589H7.05632H7.83919Z",
    fill: "#1D1D1B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13444 3.66016H2.35156V4.39302H3.13444V3.66016Z",
    fill: "#1D1D1B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92568 2.92578H3.14062V3.65865H3.92568V2.92578Z",
    fill: "#1D1D1B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 2.19531H3.92188V2.926H4.70475V2.19531Z",
    fill: "#1D1D1B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 1.46484H4.70312V2.19771H5.48821V1.46484Z",
    fill: "#1D1D1B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05013 1.46724V0.734375H6.26725H5.48438V1.46724H6.26725H7.05013Z",
    fill: "#1D1D1B"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62262 0.732865H9.40768H10.1884H10.9735H11.7563H12.5414H13.3243V0H12.5414H11.7563H10.9735H10.1884H9.40768H8.62262H7.83757H7.05469V0.732865H7.83757H8.62262Z",
    fill: "#1D1D1B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1595 5.85547H20.3766V6.58834H19.5938V7.31903V8.04972H20.3766V7.31903H21.1595H21.9424V6.58834V5.85547H21.1595Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3743 3.66016H19.5914H18.8063H18.0234V4.39302H18.8063V5.12589H19.5914V4.39302H20.3743H21.1572V3.66016H20.3743Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9689 16.8271H10.1838H9.40312H8.61806V16.0964H7.83301H7.05013V15.3657H6.26725V14.6328H5.48438V15.3657V16.0964H6.26725V16.8271H7.05013H7.83301V17.5599H8.61806H9.40312H10.1838H10.9689H11.7518H12.5368V16.8271H11.7518H10.9689Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 16.0977V16.8284H13.3219H14.1048V16.0977H13.3219H12.5391Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8844 15.3672H14.1016V16.1001H14.8844V15.3672Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48821 13.1719H4.70312V13.9047V14.6354H5.48821V13.9047V13.1719Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 11.7057V10.9729V10.2422H3.92188V10.9729V11.7057V12.4343V13.1671H4.70475V12.4343V11.7057Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70475 8.78125H3.92188V9.51411H4.70475V8.78125Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51076 13.0916V7.03395H9.24153V7.89934H10.1069V8.76472H10.9723V7.89934H11.8377V7.03395H13.5685V13.0916H11.8377V9.63011H10.9723V11.3609H10.1069V9.63011H9.24153V13.0916H7.51076Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4605_11693",
    x1: 19.205,
    y1: 19.0136,
    x2: 19.205,
    y2: 19.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4605_11693",
    x1: 19.9852,
    y1: 16.8183,
    x2: 19.9852,
    y2: 17.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4605_11693",
    x1: 18.4145,
    y1: 7.12367,
    x2: 18.4145,
    y2: 21.9515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4605_11693",
    x1: 10.1856,
    y1: 0.458991,
    x2: 10.1856,
    y2: 21.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4605_11693",
    x1: 10.5802,
    y1: 4.22347,
    x2: 10.5802,
    y2: 16.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4605_11693",
    x1: 21.1606,
    y1: 3.61097,
    x2: 21.1606,
    y2: 7.32014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4605_11693",
    x1: 17.238,
    y1: -0.0491611,
    x2: 17.238,
    y2: 3.65781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4605_11693",
    x1: 21.1606,
    y1: 3.61097,
    x2: 21.1606,
    y2: 7.32014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4605_11693",
    x1: 19.205,
    y1: 19.0136,
    x2: 19.205,
    y2: 19.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4605_11693",
    x1: 19.9852,
    y1: 16.8183,
    x2: 19.9852,
    y2: 17.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4605_11693",
    x1: 18.4145,
    y1: 7.12367,
    x2: 18.4145,
    y2: 21.9515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4605_11693",
    x1: 10.1856,
    y1: 0.458991,
    x2: 10.1856,
    y2: 21.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4605_11693",
    x1: 10.5802,
    y1: 4.22347,
    x2: 10.5802,
    y2: 16.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4605_11693",
    x1: 21.1606,
    y1: 3.61097,
    x2: 21.1606,
    y2: 7.32014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4605_11693",
    x1: 17.238,
    y1: -0.0491611,
    x2: 17.238,
    y2: 3.65781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4605_11693",
    x1: 21.1606,
    y1: 3.61097,
    x2: 21.1606,
    y2: 7.32014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.09260831d7ef432de6682fbb9068947e.svg";
export { ForwardRef as ReactComponent };